<template>
    <div>
        <div v-if="showPreview">
            <div class="mb-4" style="font-weight: 600; color: #d52323">File import có lỗi, vui lòng kiểm tra lại.</div>
            <TableErrorImportIdpExamFee :response-error="listErrors"/>
        </div>
        <div v-else style="display: flex; flex-direction: column; gap: 20px">
            <div style="display: flex; flex-direction: column">
                <label>Bước 1: Tải xuống file mẫu</label>
                <button class="btn btn-primary" style="width: 130px" @click="downloadFileExcelExample">
                    <i class="el-icon-bottom" style="color: white"></i>
                    Tải xuống
                </button>
            </div>
            <div style="display: flex; flex-direction: column">
                <label>Bước 2: Tải file excel lên hệ thống</label>
                <div v-if="fileImport" style="display: flex; align-items: center; gap: 8px">
                    <span>{{ fileImport.name }}</span>
                    <el-button class="btn-remove" type="text" @click="resetFile">
                        <i class="el-icon-delete" style="color: red !important"></i>
                    </el-button>
                </div>
                <label v-else class="btn btn-warning" for="upload-file-idp" style="width: 130px">
                    <input id="upload-file-idp" accept=".xlsx, .xls" style="display: none" type="file"
                           @change="handleFileUpload"/>
                    <i class="el-icon-top" style="color: white"></i>
                    Tải lên
                </label>
            </div>
        </div>
        <div style="display: flex; justify-content: flex-end; align-items: center; gap: 20px; margin-top: 16px">
            <button class="btn" style="background: #cacaca" @click="isBack ? backToImport() : closeDialog()">
                {{ isBack ? "Quay lại" : "Hủy bỏ" }}
            </button>
            <el-button
                v-loading="disableImport"
                :disabled="disableImport || hasRowErrors"
                class="btn btn-primary text-white"
                style="background: #5d04b0"
                @click="checkImport ? handleImportFileExcel() : handlePreviewImportFileExcel()"
            >
                {{ checkImport ? "Import" : "Xác nhận" }}
            </el-button>
        </div>
    </div>
</template>

<script>
import * as XLSX from "xlsx";
import {
    IMPORT_IDP_EXAM_REGISTER,
    PREVIEW_IMPORT_IDP_EXAM_REGISTER,
} from "@/core/services/store/idp-exam-register/idpExamRegister.module";
import {ImportIdpExamFeeModel} from "@/view/pages/manage-exam-schedule/model/ImportIdpExamFeeModel";
import TableErrorImportIdpExamFee from "@/view/pages/manage-exam-schedule/component/TableErrorImportIdpExamFee.vue";

const COLUMN_MAPPING = {
    "Mã log": "log_code",
    "Mã học viên": "student_code",
    "Trạng thái thanh toán cho IDP": "status",
};

const STATUS_MAP = {
    "chưa thanh toán": 0,
    "đã thanh toán": 1,
    "hoàn thành": 2,
    "thiếu tiền": 3,
};

const STATUS_LABELS = {
    0: "Chưa thanh toán",
    1: "Đã thanh toán",
    2: "Hoàn thành",
    3: "Thiếu tiền",
};

export default {
    name: "DialogImportIdpExamRegister",
    components: {TableErrorImportIdpExamFee},
    data() {
        return {
            fileImport: null,
            dataImport: [],
            listErrors: [],
            disableImport: false,
            checkImport: false,
            isBack: false,
        };
    },
    computed: {
        showPreview() {
            return this.listErrors.length > 0;
        },
        hasRowErrors() {
            return this.listErrors.some((item) => item.errors && item.errors.length > 0);
        },
    },
    methods: {
        downloadFileExcelExample() {
            const filePath = process.env.BASE_URL + "excel/File mẫu import phí thi IDP.xlsx";
            const a = document.createElement("a");
            a.href = filePath;
            a.download = "File mẫu import phí thi IDP.xlsx";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.fileImport = file;
                this.readExcelFile(file);
            }
            event.target.value = "";
        },
        readExcelFile(file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, {type: "array", cellDates: true});
                const firstSheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[firstSheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet, {header: 1, raw: false, dateNF: "dd/mm/yyyy"});
                const headers = (jsonData[0] || []).map((h) => (h ?? "").toString().trim());
                const rows = jsonData.slice(1);
                const columnDefs = headers
                    .map((header, colIndex) => ({header, colIndex, field: COLUMN_MAPPING[header]}))
                    .filter((col) => col.header && col.field);

                this.dataImport = rows
                    .filter((row) => Array.isArray(row) && row.some((cell) => cell !== null && cell !== undefined && cell !== ""))
                    .map((row, index) => {
                        const obj = {row_index: index + 2};
                        columnDefs.forEach(({field, colIndex}) => {
                            obj[field] = this.normalizeCell(field, row[colIndex]);
                        });
                        return obj;
                    });
                this.checkImport = false;
                this.listErrors = [];
                this.isBack = false;
            };
            reader.readAsArrayBuffer(file);
        },
        normalizeCell(field, value) {
            if (value === null || value === undefined || value === "") return null;
            const text = value.toString().trim();
            if (!text) return null;

            if (field === "status") {
                const num = Number(text);
                if (Number.isInteger(num) && num >= 0 && num <= 3) return num;
                const mapped = STATUS_MAP[text.toLowerCase()];
                return mapped !== undefined ? mapped : text;
            }
            if (field === "student_code") {
                const num = Number(String(text).replace(/\D/g, ""));
                return Number.isFinite(num) ? num : text;
            }
            if (field === "log_code") {
                return text.toUpperCase();
            }
            return text;
        },
        collectItemErrors(item) {
            if (!item) return [];
            if (Array.isArray(item.error)) return item.error.filter(Boolean);
            if (typeof item.error === "string" && item.error) return [item.error];
            if (Array.isArray(item.errors)) return item.errors.filter(Boolean);
            if (item.errors && typeof item.errors === "object") {
                return Object.values(item.errors).flat().filter(Boolean);
            }
            if (item.message) return [item.message];
            return [];
        },
        unwrapPreviewPayload(res) {
            const root = res?.data !== undefined && !Array.isArray(res?.data) ? res.data : res;
            const rows = root?.dataImport ?? root?.data ?? (Array.isArray(res?.data) ? res.data : []);
            const checkImport = root?.checkImport ?? res?.checkImport ?? root?.isError !== true;
            return {
                rows: Array.isArray(rows) ? rows : [],
                checkImport: checkImport !== false && checkImport !== 0,
            };
        },
        mapPreviewRows(rows) {
            return rows.map((item, i) => {
                const errors = this.collectItemErrors(item);
                const status = item.status;
                return new ImportIdpExamFeeModel(
                    item.row_index ?? item.row ?? i + 1,
                    {
                        log_code: item.log_code,
                        student_code: item.student_code,
                        status: STATUS_LABELS[status] !== undefined ? STATUS_LABELS[status] : status,
                    },
                    errors
                );
            });
        },
        resetFile() {
            this.fileImport = null;
            this.dataImport = [];
            this.checkImport = false;
            this.listErrors = [];
            this.isBack = false;
        },
        closeDialog() {
            this.$emit("closeDialog");
            this.$emit("setTitleError", "Import phí thi IDP");
            this.resetFile();
            this.disableImport = false;
        },
        backToImport() {
            this.resetFile();
            this.disableImport = false;
            this.$emit("setTitleError", "Import phí thi IDP");
        },
        async handlePreviewImportFileExcel() {
            this.disableImport = true;

            if (!this.fileImport) {
                this.$notify({title: "Thất bại", message: "Chưa có file nào được chọn", type: "error"});
                this.disableImport = false;
                return;
            }
            if (!this.dataImport.length) {
                this.$message.warning("Bạn không thể import khi file excel không có bản ghi nào");
                this.disableImport = false;
                return;
            }

            try {
                const res = await this.$store.dispatch(PREVIEW_IMPORT_IDP_EXAM_REGISTER, this.dataImport);
                const {rows, checkImport} = this.unwrapPreviewPayload(res);

                this.dataImport = rows.length ? rows : this.dataImport;
                this.checkImport = checkImport;
                this.listErrors = this.mapPreviewRows(rows.length ? rows : this.dataImport);
                this.isBack = true;

                if (this.hasRowErrors || !checkImport) {
                    this.$emit("setTitleError", "Báo lỗi");
                } else {
                    this.$message.success("Kiểm tra dữ liệu thành công, bấm Import để hoàn tất");
                }
            } catch (e) {
                const body = e?.data ?? e;
                const {rows} = this.unwrapPreviewPayload(body);
                if (rows.length) {
                    this.listErrors = this.mapPreviewRows(rows);
                    this.isBack = true;
                    this.$emit("setTitleError", "Báo lỗi");
                } else {
                    this.$message.error(body?.message || "Kiểm tra dữ liệu thất bại");
                }
            } finally {
                this.disableImport = false;
            }
        },
        async handleImportFileExcel() {
            this.disableImport = true;
            try {
                await this.$store.dispatch(IMPORT_IDP_EXAM_REGISTER, this.dataImport);
                this.$message.success("Import thành công");
                this.$emit("reload");
                this.closeDialog();
            } catch (e) {
                this.$message.error(e?.data?.message || e?.message || "Import thất bại");
            } finally {
                this.disableImport = false;
            }
        },
    },
};
</script>
